<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" width="80%" :append-to-body="true" :before-close="close" class="order-handle-dialog" v-loading="loading" :close-on-click-modal="false" style="height: 100%;overflow: auto;">
      <p slot="title" class="dialog-title">{{title}}</p>
      <pt-order-handle-table :isSelect="false" :tableData="rows" :tableLabels="tableLabels" :showDelete="true" v-on="$listeners"></pt-order-handle-table>
      <pt-form-item label="操作:" labelWidth="50px" :required="true">
        <el-radio-group v-model="form.result" name="result" v-validate="'required'" data-vv-as="操作">
          <el-radio v-for="(item,index) in acceptableResult" :key="index" :label="item">{{formatActionAcceptableResult(item)}}</el-radio>
        </el-radio-group>
      </pt-form-item>
      <!-- 暂时不需要表单，之后如果有上传数据验证的需求时可再配 -->
      <!-- <component :is="operate" v-model="statusForm" :sampleId="sampleId" :sampleRecollectTimes="testTimes"  ref="operate" v-if="showHandleComponent" @closeDialog="close"></component> -->
      <div class="buttons">
        <el-button type="primary" @click="certain">提&nbsp;&nbsp;交</el-button>
        <el-button type="primary" plain @click="close">取&nbsp;&nbsp;消</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
// import SAMPLE_RECOLLECT from './operate/SAMPLE_RECOLLECT'
// import MUTATION_VERIFICATION from './operate/MUTATION_VERIFICATION'
import formMixins from 'mixins/form'
import { formatActionAcceptableResult } from 'enumeration/lab-order.js'
import { tableLabels } from './order-handle-options.js'
import { handle } from 'cps/lab-order/order-status/status'
import ptOrderHandleTable from './pt-order-handle-table/handle-table'
// 组件class前缀'
const prefixCls = 'order-handle-dialog'
export default {
  name: 'order-handle-dialog',
  mixins: [formMixins],
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    // 关闭的回掉
    handleClose: {
      type: Function
    },
    title: {
      type: String,
      default: '异常处理'
    },
    rows: {
      type: Array,
      default: () => []
    }
  },
  components: {
    ptOrderHandleTable
    // SAMPLE_RECOLLECT,
    // MUTATION_VERIFICATION
  },
  data () {
    return {
      tableLabels: tableLabels,
      visible: this.dialogVisible,
      loading: false,
      form: {},
      statusForm: {}
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    acceptableResult () {
      // 多数组交集
      let res = this.rows && this.rows[0] && this.rows[0].orderActionData && this.rows[0].orderActionData.futureActionAcceptableResults ? this.rows[0].orderActionData.futureActionAcceptableResults : []
      this.rows.forEach(e => {
        if (e.orderActionData.futureActionAcceptableResults) {
          res = Array.from(new Set(res.concat([e.orderActionData.futureActionAcceptableResults])))
          res = res.filter(v => e.orderActionData.futureActionAcceptableResults.includes(v))
        }
      })
      let index = res.indexOf('RE_UPLOAD_SAMPLE_RECEIPT')
      if (index > -1) {
        res.splice(index, 1)
      }
      if (res.indexOf('SAMPLE_RECOLLECT') > -1) {
        res.splice(res.indexOf('SAMPLE_RECOLLECT'), 1)
      }
      return res
    },
    data () {
      let file = this.statusForm.file
      let res = {
        statusResult: this.form.result,
        taskIds: this.rows.map(e => e.id)
      }
      let sampleRecollectCost = this.statusForm.sampleRecollectCost
      // 上传突变验证
      if (file) {
        res.file = file
        res.attachment = {
          type: 'VERIFICATION_REQUEST',
          name: file.name
        }
      }
      // 重采
      if (sampleRecollectCost) {
        res.sampleRecollectCost = Number(sampleRecollectCost) * 100// 重采
      }
      console.log('res', res)
      return res
    }
  },
  watch: {
    task: {
      handler: function (val) {
        console.log('task', val)
      },
      immediate: true
    }
  },
  methods: {
    formatActionAcceptableResult,
    close (val) {
      this.handleClose && this.handleClose()
    },
    certain () {
      if (!this.rows || !this.rows.length) {
        this.$message.warning('您未勾选订单！')
        return
      }
      this.validate().then(formValue => {
        this.loading = true
        this.submit(this.data)
      })
    },
    async submit (data) {
      try {
        // 开始处理异常订单
        let res = await handle(data)
        console.log('res.data==========', res.data)
        this.loading = false
        this.close()
        this.$alert(res.summaryTip, '处理结果', {
          dangerouslyUseHTMLString: true
        }).then(_ => {
          this.$emit('on-success')
        })
        // this.$alert('这是一段内容', '标题名称', {
        //   confirmButtonText: '确定',
        //   callback: action => {
        //     this.$message({
        //       type: 'info',
        //       message: `action: ${ action }`
        //     });
        //   }
        // });
      } catch (error) {
        console.error(error)
        this.loading = false
        /* global _ */
        let message = _.isString(error) ? error : '操作失败！'
        this.$message.error(message)
      }
    }
  }
}
</script>

<style  lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.order-handle-dialog {
  .el-dialog {
    border-radius: 10px;
    padding: 30px;
    min-width: 500px;
    height: 100%;
    overflow: auto;
  }
  .dialog-title {
    font-weight: bold;
    font-size: 26px;
    margin-top: 0;
    margin-bottom: 0;
    line-height: 0;
  }
  el-textarea,
  .el-textarea__inner,
  .el-input__inner {
    width: 500px;
    font-family: "Microsoft YaHei", "微软雅黑", "Avenir", Helvetica, Arial;
  }
  .buttons {
    margin-top: 50px;
    .el-button {
      margin-right: 30px;
    }
  }
}
</style>
